const expandableOpenEvent = new CustomEvent('expandableopen', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const expandableCloseEvent = new CustomEvent('expandableclose', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

export function showExpandable($el) {
    if (!$el || !$el.classList.contains('expandable') || !$el.classList.contains('expandable--hide')) return;

    $el.dispatchEvent(expandableOpenEvent);

    $el.style.height = '0px';
                        
    window.requestAnimationFrame(() => {
        $el.classList.remove('expandable--hide');
        $el.style.height = `${$el.scrollHeight}px`;

        setTimeout(() => {
            $el.style.height = '';
        }, 500);
    });
}

export function hideExpandable($el) {
    if (!$el || !$el.classList.contains('expandable') || $el.classList.contains('expandable--hide')) return;

    $el.dispatchEvent(expandableCloseEvent);

    $el.style.height = `${$el.scrollHeight}px`;

    window.requestAnimationFrame(() => {
        $el.classList.add('expandable--hide');
        $el.style.height = '';
    });
}

export function toggleExpandable($el) {
    if (!$el || !$el.classList.contains('expandable')) return;

    if ($el.classList.contains('expandable--hide')) {
        showExpandable($el);
    } else {
        hideExpandable($el);
    }
}
